module.exports = __webpack_public_path__ + "img/main-collage.md.f3af5e88.jpg";